
import { useState, useEffect } from 'react';

export const useTechniquesPagination = <T,>(
  items: T[],
  itemsPerPage: number
) => {
  const [currentPage, setCurrentPage] = useState(1);
  
  // Reset to page 1 when itemsPerPage changes
  useEffect(() => {
    setCurrentPage(1);
  }, [itemsPerPage]);
  
  // Use the actual items per page value (no mobile restriction)
  const effectiveItemsPerPage = itemsPerPage;
  
  // Check if we're showing all techniques
  const showAllItems = effectiveItemsPerPage >= 1000;
  
  // Calculate pagination values
  const totalPages = showAllItems ? 1 : Math.ceil(items.length / effectiveItemsPerPage);
  const startIndex = showAllItems ? 0 : (currentPage - 1) * effectiveItemsPerPage;
  const paginatedItems = showAllItems 
    ? items 
    : items.slice(startIndex, startIndex + effectiveItemsPerPage);

  // Handle page changes with scroll to top
  const goToNextPage = () => {
    setCurrentPage((prev: number) => Math.min(prev + 1, totalPages));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const goToPrevPage = () => {
    setCurrentPage((prev: number) => Math.max(prev - 1, 1));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return {
    currentPage,
    totalPages,
    paginatedItems,
    goToNextPage,
    goToPrevPage,
    showAllItems
  };
};
